const AdminMenu = () => {
  return (
    <div>
      <h2>Error 404. No page found!</h2>
    </div>
  );
};
export default AdminMenu;
